import { useFormContext } from 'react-hook-form';
import { FieldComponentProps, ValidFieldTypes } from '../../../types';
import { validateAchRouting } from '../../../utils/validate';
import { Text } from '../../FormContainer/FormTypes/Text';

export const Routing = ({ isFetching }: FieldComponentProps) => {
  const { setValue, trigger } = useFormContext();

  return (
    <Text
      {...{
        params: {
          name: ValidFieldTypes.ROUTING,
          required: true,
          maxLength: 9,
          validate: validateAchRouting,
          disabled: isFetching,
        },
        registerOptions: {
          onChange: (e) => {
            const result = e.currentTarget.value?.replace(/[^\d]/g, '');
            setValue(ValidFieldTypes.ROUTING, result);
            trigger(ValidFieldTypes.ROUTING);
          },
        },
      }}
    />
  );
};
